var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, registerUIComponent, registerPixiComponent, DEPTHS } from "../ComponentRegistry.js";
import { Rectangle } from "../../ui/Rectangle.js";
import { Text } from "../../ui/Text.js";
import { UIService } from "../../ui/UIService.js";
import "../types.js";
import { F as FrameRateSchema, a as FrameSchema } from "../../FrameRate-7ce72a03.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../ui/UIElement.js";
import "nanoid";
import "../../ui/utils.js";
import "lodash";
import "../../inputs/InputManager.js";
import "../../utils/playSound.js";
import "../../loader/AssetLoader.js";
import "../../loader/ImageLoader.js";
import "pixi.js";
import "../../loader/SpriteLoader.js";
import "../../loader/PixiSpriteLoader.js";
import "../../loader/MapLoader.js";
import "../../utils/colors.js";
import "../../utils/sharedFetch.js";
import "../../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../../persist/persist.js";
import "../../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../../loader/SoundLoader.js";
import "../../_commonjsHelpers-7a77ea84.js";
import "../../console/flags.js";
import "../../console/editor.js";
import "../../console/floatingwindow.js";
import "../../Description-c36d0b9a.js";
import "../../Attach-abbbd93e.js";
import "../../utils/vector.js";
import "../../utils/windowSessionStorage.js";
class FrameStartSystem {
  constructor() {
    __publicField(this, "type", "FrameStart");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "depth", DEPTHS.CORE);
    __publicField(this, "schema", FrameRateSchema);
  }
  run(entity, gameModel) {
    FrameSchema.store.frame[0] = gameModel.frame;
    FrameSchema.store.__changes[0] = 1;
    const data = gameModel.getTypedUnsafe(entity, FrameRateSchema);
    const startFrameStamp = performance.now();
    data.frameRate = 1e3 / (startFrameStamp - data.startFrameStamp);
    data.startFrameStamp = startFrameStamp;
  }
}
class FrameEndSystem {
  constructor() {
    __publicField(this, "type", "FrameEnd");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "depth", DEPTHS.DRAW + 1e5);
    __publicField(this, "schema", FrameRateSchema);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, FrameRateSchema);
    data.stopFrameStamp = performance.now();
    data.averageFrameRate = data.averageFrameRate - data.averageFrameRate / 100 + data.frameRate / 100;
  }
  cleanup() {
    if (ui) {
      UIService.getInstance().removeFromUI(ui);
      ui = null;
    }
  }
}
class FrameRateSystem {
  constructor() {
    __publicField(this, "type", "FrameRate");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "schema", FrameRateSchema);
  }
  init(entity, gameModel) {
    gameModel.addComponent(entity, "Frame");
    gameModel.addComponent(entity, "FrameStart");
    gameModel.addComponent(entity, "FrameEnd");
  }
}
registerSystem(FrameStartSystem);
registerSystem(FrameEndSystem);
registerSystem(FrameRateSystem);
let ui = null;
registerUIComponent("FrameRate", (uiService, entity, gameModel) => {
  if (!ui) {
    ui = [];
    const currentFrame = new Text(new Rectangle(1600, 35, 1, 1), {
      label: "Frame: 0",
      style: {
        textTransform: "uppercase"
      },
      fontSize: 16
    });
    ui.push(currentFrame);
    uiService.addToUI(currentFrame);
    const frameTime = new Text(new Rectangle(1600, 55, 1, 1), {
      label: "000.0MS",
      style: {
        textTransform: "uppercase"
      },
      fontSize: 16
    });
    ui.push(frameTime);
    uiService.addToUI(frameTime);
    const frameRate = new Text(new Rectangle(1600, 70, 1, 1), {
      label: "00FPS",
      style: {
        textTransform: "uppercase"
      },
      fontSize: 16
    });
    ui.push(frameRate);
    uiService.addToUI(frameRate);
    const activeEntities = new Text(new Rectangle(1600, 85, 1, 1), {
      label: "0000ENT",
      style: {
        textTransform: "uppercase"
      },
      fontSize: 16
    });
    ui.push(activeEntities);
    uiService.addToUI(activeEntities);
    const activeBodies = new Text(new Rectangle(1600, 100, 1, 1), {
      label: "0000BOD",
      style: {
        textTransform: "uppercase"
      },
      fontSize: 16
    });
    ui.push(activeBodies);
    uiService.addToUI(activeBodies);
    const playerPos = new Text(new Rectangle(1600, 115, 1, 1), {
      label: "0X 0Y",
      fontSize: 16,
      style: {
        textTransform: "uppercase"
      }
    });
    ui.push(playerPos);
    uiService.addToUI(playerPos);
    const ping = new Text(new Rectangle(1600, 130, 1, 1), {
      label: "0MS PING",
      fontSize: 16,
      style: {
        textTransform: "uppercase"
      }
    });
    ui.push(ping);
    uiService.addToUI(ping);
  }
  const data = gameModel.getTypedUnsafe(entity, FrameRateSchema);
  const fps = data.stopFrameStamp - data.startFrameStamp;
  ui[0].config.label = `Frame: ${FrameSchema.store.frame[0]}`;
  ui[1].config.label = fps.toFixed(1).padStart(4, "0") + "MS";
  ui[3].config.label = (gameModel.state.activeEntities || []).length.toString().padStart(4, "0") + "ENT";
  ui[4].config.label = data.bodies.toString().padStart(4, "0") + "BOD";
  ui[6].config.label = gameModel.ping + "MS PING";
  const player = gameModel.players[0];
  const transformSchema = gameModel.getTypedUnsafe(player, TransformSchema);
  const pos = transformSchema.position;
  if (pos.x && pos.y) {
    ui[5].config.label = `${pos.x.toFixed(0)}X ${pos.y.toFixed(0)}Y`;
  }
});
class PixiFrameRate {
  constructor() {
    __publicField(this, "ids");
    __publicField(this, "init");
    __publicField(this, "cleanup");
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, FrameRateSchema);
    if (ui) {
      ui[2].config.label = data.averageFrameRate.toFixed(0) + "FPS";
    }
  }
}
registerPixiComponent("FrameRate", PixiFrameRate);
//# sourceMappingURL=FrameRate.js.map
